import { EasmFindingDetailsController } from '../controller/EasmFindingDetailsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class EasmFindingDetailsWebComponent extends BaseWebComponentElement {
  public findingId: string;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EasmFindingDetailsController,
    });
  }
}
